import { Targeting, SASTargeting } from "@digital-media/ad-model";

export interface RequesterApplication {
  area?: string;
  site: string;
  client?: string;
}

const getRequesterApplicationMap = () => {
  const applicationMap = new Map<string, RequesterApplication>();
  applicationMap.set("INSPIRE_ME", { area: "Inspire-Me", site: "Other" });
  applicationMap.set("SMARTPOINT", {
    area: "Graphical-Teaser",
    site: "Headlines",
    client: "tp",
  });
  return applicationMap;
};

export const manageRequesterApplication = (
  targetingParamsSAS: SASTargeting,
  targeting: Targeting
) => {
  const requesterApp =
    targeting.application &&
    getRequesterApplicationMap().get(targeting.application);
  if (requesterApp) {
    targetingParamsSAS.AREA = requesterApp.area;
    targetingParamsSAS.SITE = requesterApp.site;
    targetingParamsSAS.POSCLIENT = requesterApp.client;
  } else {
    targetingParamsSAS.AREA = targeting.area;
    targetingParamsSAS.SITE = targeting.site;
    targetingParamsSAS.POSCLIENT = targeting.client;
  }
};
